// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".circle[data-v-5884c994] {\n  width: 20px;\n  height: 20px;\n  position: absolute;\n  top: -10px;\n  right: -10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 50%;\n  background: #3c3cfa;\n}\n.circle .item-count[data-v-5884c994] {\n  color: #ffffff;\n  text-align: center;\n  font-size: 0.7rem;\n}", ""]);
// Exports
module.exports = exports;
